export const getCookieId = () => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; id=`);
  return parts.pop().split(";").shift();
};
